/* SearchLoading.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _21 = "@media (min-width:64rem){._dm25glyw{display:none}}";
const _20 = "._1e0c1ule{display:block}";
const _19 = "@media (min-width:64rem){._dm251ule{display:block}}";
const _18 = "._vwz4f6fq{line-height:18px}";
const _17 = "._k48p1nn1{font-weight:400}";
const _16 = "._ect418aq{font-family:var(--ds-font-family-brand-body,\"Charlie Text\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const _15 = "._1wyboqnp{font-size:.75rem}";
const _14 = "._syaz1gjq{color:var(--ds-text-subtle,#44546f)}";
const _13 = "._1e0cglyw{display:none}";
const _12 = "._o5721q9c{white-space:nowrap}";
const _11 = "._1bto1l2s{text-overflow:ellipsis}";
const _10 = "._18u0idpf{margin-left:0}";
const _9 = "._otyridpf{margin-bottom:0}";
const _8 = "._2hwxidpf{margin-right:0}";
const _7 = "._19pkidpf{margin-top:0}";
const _6 = "._18m915vq{overflow-y:hidden}";
const _5 = "._1reo15vq{overflow-x:hidden}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Spinner from '@atlaskit/spinner';
import { BodySmall } from '@atlassian/mpac-primitives';
import { ellipsisCompiled } from '@atlassian/mpac-ui/theme';
import React from 'react';
import { desktopOnly, mobileOnly } from '../../SearchUtils/ResponsiveUtils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _4 = "._1tke1mjv{min-height:300px}";
const _3 = "._1e0c1txw{display:flex}";
const _2 = "._zulpu2gc{gap:var(--ds-space-100,8px)}";
const _ = "._1yt4oxwe{padding:var(--ds-space-250,20px) var(--ds-space-250,20px) var(--ds-space-050,4px) var(--ds-space-300,24px)}";
const Container = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt4oxwe _zulpu2gc _1e0c1txw _1tke1mjv", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Container.displayName = 'Container';
}
const baseLabel = {
  color: "var(--ds-text-subtle, #44546F)",
  fontSize: '0.75rem',
  fontFamily: "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  fontWeight: 400,
  lineHeight: '18px',
  margin: 0
};
const LargeLabel = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = BodySmall,
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1reo15vq _18m915vq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1bto1l2s _o5721q9c _1e0cglyw _syaz1gjq _1wyboqnp _ect418aq _k48p1nn1 _vwz4f6fq _dm251ule", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  LargeLabel.displayName = 'LargeLabel';
}
const SmallLabel = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = BodySmall,
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_5, _6, _7, _8, _9, _10, _11, _12, _20, _14, _15, _16, _17, _18, _21]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1reo15vq _18m915vq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1bto1l2s _o5721q9c _1e0c1ule _syaz1gjq _1wyboqnp _ect418aq _k48p1nn1 _vwz4f6fq _dm25glyw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  SmallLabel.displayName = 'SmallLabel';
}
export const SearchLoading = _ref4 => {
  let {
    query = 'suggesti'
  } = _ref4;
  return /*#__PURE__*/_jsxs(Container, {
    "data-testid": "skeleton-items",
    children: [/*#__PURE__*/_jsxs(LargeLabel, {
      as: "h3",
      children: ["Suggestions for \u2018", query, "\u2019"]
    }), /*#__PURE__*/_jsx(SmallLabel, {
      children: "Suggestions"
    }), /*#__PURE__*/_jsx(Spinner, {
      interactionName: "load",
      size: "small"
    })]
  });
};